module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "module-name"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "icon-globe font-dark hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark bold uppercase"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.showLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (!_vm.showLoading) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showList) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.forms), function(form, index) {
    return (_vm.showForm(form)) ? _c('li', {
      staticClass: "list-group-item",
      class: {
        'open': _vm.isParent(form.data)
      }
    }, [_c('collapse', {
      attrs: {
        "selected": false
      }
    }, [_c('div', {
      staticClass: "collapsible-header",
      attrs: {
        "slot": "collapsible-header"
      },
      slot: "collapsible-header"
    }, [_c('h4', [_vm._v(_vm._s(form.name) + " (" + _vm._s(form.data.length) + " record" + _vm._s((form.data.length !== 1) ? 's' : '') + ")")]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [(!form.read_only) ? _c('button', {
      staticClass: "btn green",
      attrs: {
        "disabled": !form.multiple_entries && (form.data.length !== 0)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.fillForm(index, form.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                    Complete Form\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn default btn-show-completed-forms mt-ladda-btn ladda-button",
      attrs: {
        "data-style": "expand-left",
        "type": "button",
        "disabled": form.data.length === 0
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.showFormsTables.includes(form.id, $event) ? _vm.hideCompletedFormsTable(form.id) : _vm.showCompletedFormsTable(form.id, $event)
        }
      }
    }, [_c('span', {
      staticClass: "ladda-label"
    }, [_vm._v(_vm._s(_vm.showFormsTables.includes(form.id) ? 'Hide all' : 'Show all'))])])])]), _vm._v(" "), _c('div', {
      staticClass: "collapsible-body",
      attrs: {
        "slot": "collapsible-body"
      },
      slot: "collapsible-body"
    }, [(form.data.length === 0) ? _c('h4', [_vm._v("0 records found")]) : _vm._e(), _vm._v(" "), (_vm.showFormsTables.includes(form.id)) ? [(form.hasOwnProperty('results')) ? _c('vue-good-table', {
      attrs: {
        "columns": _vm.convertVueTableDateColumnsToLeftAlign(form.results.columns),
        "rows": _vm.convertVueTableRowsArrayValueToPreviewNotAvailableString(form.results.rows),
        "sort-options": _vm.sortOptions,
        "globalSearch": false,
        "paginate": false,
        "styleClass": "table table-bordered show-all-results vgt-table"
      },
      scopedSlots: _vm._u([{
        key: "table-row",
        fn: function(props) {
          return [(props.column.field === 'before') ? _c('span', [_c('a', {
            on: {
              "click": function($event) {
                return _vm.editForm(props.index, form.id, props.row.id)
              }
            }
          }, [_vm._v("Edit")])]) : _vm._e(), _vm._v(" "), (props.column.type === 'date') ? _c('span', [_vm._v(_vm._s(props.row[props.column.field]))]) : (props.column.field.startsWith('file-')) ? _c('span', _vm._l((props.row[props.column.field]), function(file) {
            return _c('a', {
              attrs: {
                "href": _vm.getFileUrl(props.column.field, file),
                "target": "_blank"
              }
            }, [_vm._v("\n                          " + _vm._s(file.name) + "\n                        ")])
          }), 0) : _c('span', {
            domProps: {
              "innerHTML": _vm._s(props.formattedRow[props.column.field] + '')
            }
          })]
        }
      }], null, true)
    }) : _vm._e()] : [_c('div', {
      staticClass: "mt-comments row"
    }, _vm._l((form.data), function(record, index) {
      return _c('div', {
        staticClass: "mt-comment",
        class: {
          'active': _vm.isSelected(record.id)
        },
        attrs: {
          "data-id": record.id
        }
      }, [_c('div', {
        staticClass: "mt-comment-body"
      }, [_c('div', {
        staticClass: "mt-comment-info"
      }, [_c('span', {
        staticClass: "mt-comment-author"
      }, [_vm._v(" " + _vm._s(form.name) + " ")]), _vm._v(" "), _c('span', {
        staticClass: "mt-comment-date"
      }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(record.created_date.date)) + " ")])]), _vm._v(" "), _c('div', {
        staticClass: "mt-comment-text"
      }, [_vm._v(" Completed By: "), _c('b', [_vm._v(_vm._s(record.creator))])]), _vm._v(" "), _c('div', {
        staticClass: "mt-comment-details"
      }, [_c('ul', {
        staticClass: "mt-comment-actions"
      }, [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.editForm(index, form.id, record.id)
          }
        }
      }, [_vm._v("Edit")])]), _vm._v(" "), (_vm.user.access > 2 && !_vm.forceReadOnly) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.removeFormModal(record.id)
          }
        }
      }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.printPage('/print/form/' + record.id)
          }
        }
      }, [_vm._v("Print")])]), _vm._v(" "), (!_vm.forceReadOnly) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.duplicateForm(record.id)
          }
        }
      }, [_vm._v("Duplicate")])]) : _vm._e()])])])])
    }), 0)]], 2)])], 1) : _vm._e()
  }), 0) : _c('div', {
    attrs: {
      "id": "widgetForm"
    }
  }, [_c('vue-form-render', {
    ref: "formRender",
    attrs: {
      "schema": _vm.currentForm.schema,
      "conditions": _vm.currentForm.conditions,
      "update-conditions": _vm.currentForm.updateConditions,
      "hideValues": _vm.currentForm.hide_values,
      "calculations": _vm.currentForm.calculations,
      "validation-conditions": _vm.currentForm.extra_validation_rules,
      "values": _vm.currentForm.values,
      "date-format": _vm.user.date_format,
      "user-access-level": _vm.user.access,
      "lockform": _vm.forceReadOnly,
      "form-previews": _vm.currentForm.form_previews,
      "name": "widgetForm"
    },
    on: {
      "validation-failed": function($event) {
        _vm.sendToParticipantMethod = null
      }
    }
  }), _vm._v(" "), (!_vm.forceReadOnly) ? _c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button formSave",
    attrs: {
      "data-style": "expand-left",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit()
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.showSendToParticipantButton()) ? _c('button', {
    staticClass: "btn default mt-ladda-btn ladda-button formSave",
    attrs: {
      "disabled": !_vm.sendToParticipantButtonEnabled(),
      "data-style": "expand-left",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displaySendModal()
      }
    }
  }, [_vm._v("Send to " + _vm._s(_vm.participantSingularName) + " and Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "activity-info-container"
  }, [(_vm.currentForm.info.length != 0) ? _c('h4', {
    staticClass: "activity-info"
  }, [_vm._v("ACTIVITY LOGGING")]) : _vm._e(), _vm._v(" "), (_vm.currentForm.info.created_date != null) ? _c('span', [_vm._v("Completed By: "), _c('b', [_vm._v(_vm._s(_vm.currentForm.info.creator))]), _vm._v(" at " + _vm._s(_vm._f("formatDate")(_vm.currentForm.info.created_date.date))), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isEqual(_vm.currentForm.info.created_date, _vm.currentForm.info.updated_date)) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getEditor(_vm.currentForm.info))
    }
  })]) : _vm._e(), _vm._v(" "), _c('span'), _vm._v(" "), ((_vm.currentForm.info.created_date != null) && !['organization_general', 'organization_organization'].includes(_vm.currentForm.module_key)) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCase(_vm.currentForm.info))
    }
  }) : _vm._e()])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "id": "remove_modal",
      "title": "DELETE FORM",
      "question": "Are you sure you would like to delete this form?"
    },
    on: {
      "confirmed": function($event) {
        return _vm.removeForm(_vm.currentDelete)
      }
    }
  }), _vm._v(" "), (_vm.displaySendToParticipantModal) ? _c('send-to-participant-modal', {
    on: {
      "send": function($event) {
        return _vm.sendToParticipantAndSave($event)
      },
      "cancel": _vm.cancelSendToParticipant,
      "display": function($event) {
        _vm.displaySendToParticipantModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a37e41e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/FormCRUD.vue
// module id = 1729
// module chunks = 1